export function el(html: string): HTMLElement {
  const wrap = document.createElement('div')
  wrap.innerHTML = html.trim()
  const first = wrap.firstElementChild
  if (!first) throw new Error('el(): empty markup')
  return first as HTMLElement
}

/** Append every top-level element from an HTML string (el() only returns the first). */
export function appendBlocks(parent: HTMLElement, html: string): void {
  const wrap = document.createElement('div')
  wrap.innerHTML = html.trim()
  while (wrap.firstElementChild) {
    parent.appendChild(wrap.firstElementChild)
  }
}

export function setStatus(
  node: HTMLElement,
  text: string,
  kind: 'ok' | 'err' | 'muted' = 'muted',
): void {
  node.textContent = text
  node.className = `status ${kind}`
}

export function escapeHtml(text: string): string {
  return text
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
}

/** Copia testo — fallback per iOS/PWA dove clipboard API fallisce. */
export async function copyText(text: string): Promise<boolean> {
  const value = text.trim()
  if (!value || value === '…' || value === '—') return false
  try {
    if (navigator.clipboard?.writeText) {
      await navigator.clipboard.writeText(value)
      return true
    }
  } catch {
    /* fallback sotto */
  }
  try {
    const ta = document.createElement('textarea')
    ta.value = value
    ta.setAttribute('readonly', '')
    ta.style.position = 'fixed'
    ta.style.left = '-9999px'
    document.body.appendChild(ta)
    ta.focus()
    ta.select()
    ta.setSelectionRange(0, value.length)
    const ok = document.execCommand('copy')
    ta.remove()
    return ok
  } catch {
    return false
  }
}
